module.exports = __webpack_public_path__ + "static/media/drake.403f0efe.jpg";